import React, { useEffect, useState } from 'react'
import Home from '../../Home/Home';
import UI from '../../DataWithFilter/UI';
import { commonFetchData, getLocalStorageData } from '../../../utils/commanFunctions';
import { Header } from '../Header';
import SmallMapCard from '../../Trip/SmallMapCard';
import Spinner from '../../spinner/Spinner';
import NoDataFoundSmall from '../NoDataFoundSmall';

const MyFavorite = () => {
    const title = "My Favorites";
    const bookMData = getLocalStorageData("tripBookmarked", { ids: [] }) || { ids: [] };
    const apiParams = bookMData.ids.join(",");



    const [data, setData] = useState([]);
    const [noData, setNoData] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedFilter, setSelectedFilter] = useState({
      "display_value": "All",
      "query_value": "all"
    });


    useEffect(() => {
        const fetchData = async () => {
          try {
            setIsLoading(true)
            let url = `data-aggregator/places-events/${apiParams ?"?id__in="+apiParams:""}`;
            const [placesResponse] = await Promise.all([
              commonFetchData(url, { req: "get", onErrorData: {} }),
            ]);
            setData(Object.keys(placesResponse).length > 0 ? placesResponse?.results : []);
            setNoData(placesResponse.length === 0);
          } catch (error) {
            console.error("Data fetching error:", error);
            setNoData(true);
          } finally {
            setIsLoading(false);
          }
        };
      if(apiParams)
      fetchData();
    else {
      if (isLoading) setIsLoading(false);
      setNoData(true);
    }
      }, [apiParams]); 

      console.log(data, "data")

  return (
    <Home nav={"List"} showBottomNav={true} showPersonalizedButton={false} showOldFilter={false}  >
    <Header data={{
        title:title,
        // buttonText:"List",
        // buttonUrl:"/?path=trip",
      }}
    showFilter={false}
    showSearch={false}
    showBookMark={false} />
    <div className='h-full max-w-[1000px] mx-auto'>

      {isLoading ? (<div className="w-full flex justify-center items-center py-10 min-h-[50vh]">
        <Spinner />
      </div>):
      noData ? <NoDataFoundSmall/> :
      <>
      
      <div style={{width: "100%", borderRadius:"20px", padding:"66px 16px 16px 16px"}}> <SmallMapCard locations={data} mapHeight="236px" rounded={true} /></div>

      <UI name={"Your favorites"} showHeader={true} parentDivClass={"my-favorites"} showBookMark={true} isFilter={true} url={`data-aggregator/places-events/${apiParams ?"?id__in="+apiParams:""}`}  data={data} selectedFilter={selectedFilter} showTotalItems={true} setSelectedFilter={setSelectedFilter} setData={(d) => {
  if (Array.isArray(d)) {
    setData([]);
  } else if (d && typeof d === "object") {
    setData(d.results || []);
  } else {
    setData([]);
  }
}} isloading={isLoading} setIsLoading={setIsLoading} noData={noData} setNoData={setNoData}/>
</>
}
    </div>
    </Home>
  )
}

export default MyFavorite
